const hasValue = (data) =>
  Object?.values(data)?.some((value) => value !== undefined);

export default hasValue;
